import React, { useState } from "react";
import PropTypes from "prop-types";

import { Icon, Loader } from "semantic-ui-react";

import { EmbedVideoSkeleton } from "./components";

function getEmbedURL(url) {
  if (!url) return null;

  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    const videoID = url.split("v=")[1]?.split("&")[0] || url.split("/").pop();
    return `https://www.youtube.com/embed/${videoID}`;
  }
  if (url.includes("loom.com")) {
    return url.replace("/share/", "/embed/");
  }
  if (url.includes("synthesia.io")) {
    const parts = url.split("/");
    const videoID = parts[parts.length - 1];
    return `https://share.synthesia.io/embeds/videos/${videoID}`;
  }

  return null;
}

function EmbedVideo({ src, title, width, height }) {
  const [loaded, setLoaded] = useState(false);
  const embedUrl = getEmbedURL(src);

  if (!embedUrl) {
    return (
      <div style={{ position: "relative", width: width, height: height }}>
        <EmbedVideoSkeleton>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1em",
              alignItems: "center",
            }}
          >
            <Icon size="big" name="video" color="grey" />
            Video unavailable
          </div>
        </EmbedVideoSkeleton>
      </div>
    );
  }

  return (
    <div style={{ position: "relative", width: width, height: height }}>
      {!loaded && (
        <EmbedVideoSkeleton>
          <Loader active />
        </EmbedVideoSkeleton>
      )}

      <iframe
        src={embedUrl}
        width={width}
        height={height}
        allowFullScreen
        title={title}
        onLoad={() => {
          return setLoaded(true);
        }}
        style={{ borderRadius: "6px", border: "none" }}
      />
    </div>
  );
}

EmbedVideo.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

EmbedVideo.defaultProps = {
  title: "Embedded Video",
  width: "560px",
  height: "315px",
};

export default EmbedVideo;
